import styled from "@emotion/styled";

export const Container = styled("span")(({ theme }) => ({
    display: "flex",
    [theme.breakpoints.down("md")]: {
        display: "block",
    },
}));
